import React, { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';      
import RemoveIcon from '@mui/icons-material/Remove'; 
import './index.css';

const PartnershipFAQ = () => {
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const handleFaqToggle = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };
  const PARTNERSHIP_FAQ_DATA = [
  {
    category: "About Partnership",
    questions: [
      { q: "What does “Partner With Us” mean at MarkoKnow?", a: "Partnering with MarkoKnow means joining forces to create learning, community, and employability impact together — whether through joint programs, content collaboration, student engagement, or ecosystem initiatives." },
      { q: "Who can partner with MarkoKnow?", a: "We partner with educational institutions, corporates & startups, industry experts & mentors, community platforms, government & NGO groups, and anyone aligned with our mission of building employability." },
      { q: "What types of partnerships does MarkoKnow support?", a: "Partnership types include Academic partnerships (content co-creation), Industry collaborations (internships, hiring pathways), Mentor ecosystems, Event partnerships, and Research & impact alliances." }
    ]
  },
  {
    category: "Partnership Benefits",
    questions: [
      { q: "What are the benefits of partnering with MarkoKnow?", a: "Partners gain access to a high-engagement learner community, branding visibility with students & industries, co-designed knowledge initiatives, and data-driven insights into talent trends." },
      { q: "Can partners recruit or hire from the MarkoKnow community?", a: "Yes — partners can explore talent engagement opportunities, including curated candidate pools, internships, and hiring collaborations depending on availability and alignment." }
    ]
  },
  {
    category: "Process & Requirements",
    questions: [
      { q: "How do I apply to become a partner?", a: "Click the Partner With Us form on the page, fill in your details, and submit your proposal. Our team will review and respond within the stated timeline." },
      { q: "Is there a cost to partner with MarkoKnow?", a: "Costs vary based on scope and objectives. Some collaborations are mutually beneficial and cost-free, while others may involve customized programs or engagements." },
      { q: "How long does the partnership review take?", a: "We aim to review partnership applications within 7–14 business days, depending on the complexity of the proposal." },
      { q: "What information should I include in my partnership proposal?", a: "Include your organization’s profile, partnership objectives, expected outcomes, proposed engagement model, timeline, and contact information." }
    ]
  }
  // Add remaining categories following this same structure
];

  return (
    <section className="mk-faq-wrapper">
      <div className="mk-faq-container">
        <h2 className="mk-faq-main-header">Partnership FAQs</h2>
        
        {PARTNERSHIP_FAQ_DATA.map((section, sIdx) => (
          <div key={sIdx} className="mk-faq-group">
            <h3 className="mk-faq-category-title">{section.category}</h3>
            <div className="mk-faq-list-box">
              {section.questions.map((item, qIdx) => {
                const gIdx = `${sIdx}-${qIdx}`;
                const isOpen = openFaqIndex === gIdx;
                
                return (
                  <div key={qIdx} className={`mk-faq-item ${isOpen ? 'is-open' : ''}`}>
                    <button className="mk-faq-question-bar" onClick={() => handleFaqToggle(gIdx)}>
                      <span>{item.q}</span>
                      {isOpen ? (
                        <RemoveIcon sx={{ fontSize: 22, color: '#8257E6' }} /> 
                      ) : (
                        <AddIcon sx={{ fontSize: 22, color: '#666' }} />
                      )}
                    </button>
                    <div className="mk-faq-answer-drawer">
                      <div className="mk-faq-answer-inner">
                        <p className="mk-answer-text">{item.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PartnershipFAQ;